import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import { Modal, Form, Button, Row, Col } from 'react-bootstrap'
import getUserFullName from '../../../utilities/get-user-full-name'
import useMessageCreation from '../../../hooks/use-message-creation'
import utilities from '../../../utilities'

const CreateMessageModal = ({
    recipients = [],
    subject = '',
    onHide,
}) => {
    const { isError, isCreating, createMessage } = useMessageCreation({ onCreated: onHide })
    const [ message, setMessage ] = useState({ subject, recipientIds: recipients.map(r => r.id) })
    const recipientNames = recipients.map(u => utilities.getUserFullName(u, { grade: true })).join(', ')

    return createPortal(
        <Modal
            show
            onHide={() => onHide()}
            size='lg'
        >
            <Modal.Header closeButton={!isCreating}>
                <Modal.Title>Compose Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Recipient</Form.Label>
                        <Form.Control
                            type="text"
                            value={recipientNames}
                            readOnly
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Subject</Form.Label>
                        <Form.Control
                            type="text"
                            value={message.subject || ''}
                            onChange={e => setMessage({ ...message, subject: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            value={message.content || ''}
                            onChange={e => setMessage({ ...message, content: e.target.value })}
                        />
                    </Form.Group>
                </Form>
                {isError && <span>There was an error sending this message.</span>}
                <Row>
                    <Col
                        md={{ span: 4, offset: 8}}
                    >
                        <Row>
                            <Col><Button block onClick={() => createMessage(message)} disabled={isCreating}>{isCreating ? 'SENDING...' : 'SEND'}</Button></Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
        , document.body)
}

export default CreateMessageModal